/* eslint-disable no-console */
import { NODE_ENV } from '../environment'

export function logDebug(tag: string, ...args: unknown[]) {
  if (NODE_ENV === 'development') {
    console.log(`%cIconicBuilder:${tag}`, 'background: #12421B; color: #3DCD58; padding: 0 1em; border-radius: 100px;', ...args)
  }
}

export function logErrorDebug(tag: string, ...args: unknown[]) {
  if (NODE_ENV === 'development') {
    console.error(tag, ...args)
  }
}
